<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <div class="form-list-usaha">
      <div class="list-usaha">
        <div class="list-usaha-content list-usaha-content__title">
          <p class="column10">Kode</p>
          <p class="column30 mr10">Judul</p>
          <p class="column10">NIB</p>
          <p class="column10">SS IZIN</p>
          <p class="column20">Dokumen Lainnya</p>
          <p class="column15">Tingkat Resiko</p>
        </div>
        <div
          class="list-usaha-content"
          v-for="(list, index) in addedKbli"
          :key="index"
        >
          <p class="column10">{{ list.kode }}</p>
          <p class="column30 col-nohover mr10">{{ list.desc }}</p>
          <p class="column10">
            <input
              type="checkbox"
              :value="list.nib && list.nib"
              v-model="addedKbli[index]['nib']"
              :disabled="disabled"
            />
            {{ list.nib ? 'Ya' : 'Tidak' }}
          </p>
          <p class="column10">
            <input
              type="checkbox"
              :value="list.ss_izin && list.ss_izin"
              v-model="addedKbli[index]['ss_izin']"
              :disabled="disabled"
            />
            {{ list.ss_izin ? 'Ya' : 'Tidak' }}
          </p>
          <p class="column20">
            <input
              type="checkbox"
              :value="list.dokumen_lainnya && list.dokumen_lainnya"
              v-model="addedKbli[index]['dokumen_lainnya']"
              :disabled="disabled"
            />
            {{ list.dokumen_lainnya ? 'Ya' : 'Tidak' }}
          </p>
          <p class="column15">{{ list.skala_besar }}</p>
        </div>
      </div>
      <div @click="openModalKbli()" class="btn-landing-icons" v-if="!disabled">
        <p class="icons-btn-landing">+</p>
        <a class="text-btn-landing">Tambah</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'modelName',
    'label',
    'storeName',
    'mutationName',
    'isRequired',
    'modalName',
    'disabled',
  ],
  computed: {
    addedKbli: {
      get: function() {
        return this.$store.state[this.storeName][this.modelName]
      },
      set: function(newValue) {},
    },
  },
  methods: {
    openModalKbli() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: true,
      })
    },
  },
}
</script>
